module.exports = __webpack_public_path__ + "static/media/site-logo.18887b33.svg";